<template>
    <layout-card
        :isCustomizable="settings.isCustomizable"
        :loading="loading"
        :placeholder="placeholder"
        placeholderImg="/ressources/logged/img/dashboard/dashboard-bank.svg"
        :type="settings.context"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
        class="bank-account-balance-card"
        >
        <!-- TITLE -->
        <template slot="title">{{ name }}</template>
        <!-- SLOTED ACTIONS -->
        <template slot="actions">
            <portal to="dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    :cardSettings="settings"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </portal>
        </template>
        <!-- CONTENT -->
        <template slot="content">
            <div v-if="cardData && cardData.length > 0" class="ov-auto">
                <!-- TOTAL BALANCE OF ACCOUNTS -->
                <div class="acenter mt-2 mb-4">
                    <p class="mb-2">{{ $l10n.__('Total de vos comptes bancaires') }}</p>
                    <p class="bold fs-6" :class="{ red : totalBalance < 0 }">{{ totalBalance() | numberformat(true) }}</p>
                </div>
                <!-- TABLE OF ACCOUNTS -->
                <el-table
                    :data="cardData"
                    :show-header="false"
                    row-class-name="no-hover"
                    stripe
                    >
                    <el-table-column
                        prop="label"
                        class-name="semibold lc-2"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="balance"
                        align="right"
                        class-name="semibold"
                        >
                        <template slot-scope="scope">
                            <span :class="{ red : scope.row.balance < 0 }">
                                {{ scope.row.balance | numberformatWithOptions({currencysymbol : scope.row.currencySymbol}, true) }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </template>
    </layout-card>
</template>

<script>
    import LayoutCard from './LayoutCard.vue';
    import CardMixin from './CardMixin.js';
    import { goToUrl } from '../../../helpers.js';
    
    export default {
        mixins : [CardMixin],
        data() {
            return {
                settingsFormName : 'bank-account-balance-setting-form'
            }
        },
        methods : {
            totalBalance() {
                var compute = 0;
                this.cardData.forEach(account => {
                    if (
                        account.balance != null &&
                        account.currencyId == App.numformat.currencyid
                    ) {
                        compute += parseFloat(account.balance);
                    }
                });
                return compute;
            },
        },
        computed : {
            placeholder() {
                return this.$l10n.__("Vous n'avez pas de compte configuré.");
            }
        },
        components: {
            LayoutCard,
        }
    }
</script>

<style lang="scss">
    @import '~@sellsy/styleguide/src/_variables';
    @import '~@sellsy/styleguide/src/_mixins';

    .bank-account-balance-card {
        .el-table__row--striped.no-hover {
            td {
                background-color: #F3F3FB !important;
                border-bottom: none !important;

                &:first-child {
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                }
                &:last-child {
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                }
            }
            &:hover > td {
                background-color: #F3F3FB !important;
            }
        }
        .no-hover {
            td {
                border-bottom: none !important;
            }
            &:hover > td {
                background-color: transparent !important;
            }
        }
        .el-table:before {
            height: 0;
        }
        .el-table .cell {
            word-break: break-word;
        }
    }
</style>